$(document).ready(function() {
    
    const cursor = $(".cursor");
    let scale = 1;
    let mouseX = 0;
    let mouseY = 0;

    jQuery.fn.highlight = function (str, className) {    
        var regex = new RegExp(str, "gi");
        return this.each(function () {
            this.innerHTML = this.innerHTML.replace(regex, function(matched) {return "<span class=\"" + className + "\">" + matched + "</span>";});
        });
    };
    $(".page-content").highlight("£","currency-symbol");

    function updateCursor() {
        cursor.css({
            top: mouseY,
            left: mouseX,
            transform: `translate(-50%, -50%) scale(${scale})`
        });
        requestAnimationFrame(updateCursor);
    }

    $(document).on("mousemove", function(e) {
        if ($(window).width() > 768) {
            mouseX = e.clientX;
            mouseY = e.clientY;
        }
    });

    requestAnimationFrame(updateCursor);

    $(document).on({
        "mouseenter mousemove": function() {
            $('.cursor').addClass('outline');
            scale = 1.2;
        },
        "mouseleave": function() {
            $('.cursor').removeClass('outline');
            scale = 1;
        }
    }, "a,button");

    //Announcement Bar
    if (!Cookies.get('announcementBar')) {
        let announcementBarHeight = 0;
        const announcementText = $('.announcement-bar-v2 .announcement-text');
        announcementText.each(function() {
            const textHeight = $(this).outerHeight();
            if(textHeight > announcementBarHeight || !announcementBarHeight){
                announcementBarHeight = textHeight;
            }
        });
        announcementBarHeight = announcementBarHeight + 24;
        document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
        $('.announcement-bar-v2').outerHeight(announcementBarHeight);
    }else{
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        setTimeout(function() {
            $('.announcement-bar-v2').remove();
        }, 500);
    }
    $(document).on('click', '.announcement-bar-v2 .close-announcement-bar', function() {
        $('body').addClass('announcement-bar-closing');
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
        $('.announcement-bar-v2').outerHeight(0);
        Cookies.set('announcementBar', 'closed', { expires: 7 });
        setTimeout(function() {
            $('body').removeClass('announcement-bar-closing');
            $('.announcement-bar-v2').remove();
        }, 500);
    });
    if($('.announcement-text-slider').length){
        $('.announcement-text-slider').flickity({
            pageDots: false,
            wrapAround: true,
            prevNextButtons: false,
            cellAlign: 'center',
            groupCells: 1,
            autoPlay: 5000,
            pauseAutoPlayOnHover: true
        });
    };

    //Sidebar Menu
    $(document).on('click', '.sidebar-menu-trigger', function() {
        if($(this).parents('.section-header').length && $(this).parents('.section-header').hasClass('cart-open')){
            const cartLink = $('#cart-icon-bubble')[0];
            const cartDrawer = $('cart-drawer')[0];
            cartDrawer.close();
            $('.section-header').removeClass('cart-open');
        }else{
            if($(window).width() < 1025){
                $('body').toggleClass('overflow-hidden');
                $('.section-header').toggleClass('menu-open');
            }
            $(this).toggleClass('open');
            $('.sidebar-menu').toggleClass('open');
        }
    });
    
    // Landing
    function fallingObjects(el, image) {
        const { Engine, Runner, Render, Bodies, Composite, Body } = Matter;
        const engine = Engine.create();
        const canvasWidth = $(el).parent().width() * 2;
        const canvasHeight = $(el).parent().height() * 2;
        const render = Render.create({
            element: el,
            engine: engine,
            options: {
                width: canvasWidth,
                height: canvasHeight,
                pixelRatio: 1,
                background: 'transparent',
                wireframes: false // <-- important
            }
        });
        const images = Array.from({ length: 50 }, (_, i) => {
            const x = Math.random() * canvasWidth; // Random x-coordinate within the canvas width
            const y = i * -100; // Fixed y-coordinate
            return Bodies.rectangle(x, y, 60, 60, {
                render: {
                    sprite: {
                        texture: image,
                        xScale: 1.2, 
                        yScale: 1.2
                    }
                }
            });
        });
        //the images should be stopped from falling through the bottom of the canvas
        const floor = Bodies.rectangle(canvasWidth/2, canvasHeight + 10, canvasWidth, 10, { isStatic: true });
        Composite.add(engine.world, [...images, floor]);
        images.forEach(image => Body.applyForce(image, { x: image.position.x, y: image.position.y }, { x: 0, y: 0.2 }));
        Render.run(render);
        Runner.run(Runner.create(), engine);
    }
    function runFallingObjects() {
        $('#falling-emojis').empty();
        fallingObjects($('#falling-emojis')[0], $('.landing-media').attr('data-emoji'));
    }
    if($('.landing-section').length){
        $('.landing-cta a').hover(function() {
            runFallingObjects();
        }, function() {
            $('#falling-emojis').empty();
        });
    }
    if($('.landing-v2-section').length){
        $('.landing-circle a').hover(function() {
            runFallingObjects();
        }, function() {
            console.log('a');
            $('#falling-emojis').empty();
        });
    }

    //Featured Collection v2
    if($('.featured-collection-v2').length){
        const sectionTitle = $('.section-title');
        const titleWrapper = $('.title-wrapper');
        const animatedLetter = $('.animated-letter');
        let sectionTitleWidth = sectionTitle.width();
        let wrapperWidth = titleWrapper.width();
        let letterWidth = animatedLetter.width();
        let widthDiff = sectionTitleWidth - wrapperWidth;
        let maxLetters = Math.floor(widthDiff / letterWidth);
        function updateLetterContent() {
            if($(window).width() > 768){
                if($(window).width() < 1025){
                    maxLetters = 6;
                }
                const scrollTop = $(window).scrollTop();
                const windowBottom = $(window).scrollTop() + $(window).height();
                if(windowBottom >= $('.featured-collection-v2').offset().top && scrollTop <= $('.featured-collection-v2').offset().top + $('.featured-collection-v2').outerHeight()){
                    let lettersToAdd = Math.floor((windowBottom - $('.featured-collection-v2').offset().top) / 100) + 1;
                    if(lettersToAdd > maxLetters){
                        lettersToAdd = maxLetters;
                    }
                    if(lettersToAdd < 1){
                        lettersToAdd = 1;
                    }
                    let newContent = '';
                    for (var i = 0; i < lettersToAdd; i++) {
                        newContent += animatedLetter.attr('data-letter');
                    }
                    animatedLetter.text(newContent);
                }
            }
        }
        function updateOnResize() {
            animatedLetter.text(animatedLetter.attr('data-letter'));
            sectionTitleWidth = sectionTitle.width();
            wrapperWidth = titleWrapper.width();
            letterWidth = animatedLetter.width();
            widthDiff = sectionTitleWidth - wrapperWidth;
            maxLetters = Math.floor(widthDiff / letterWidth);
            animatedLetter.text(animatedLetter.attr('data-letter'));
            updateLetterContent();
        }
        $(window).on('resize', updateOnResize);
        updateLetterContent();
    }

    //Reviews Section
    $(document).on('mouseenter', '.reviews-box', function() {
        const imageIndex = $(this).index();
        $(this).parents('.reviews-content').next().find('.reviews-photo').eq(imageIndex).addClass('active').siblings().removeClass('active');
    })

    //Alternating Images
    if($('.alternating-images').length){
        let alternatingImagesInterval;
        let order = [2,4,1,3];
        let index = 0;
        function updateImagesList() {
            if($(window).width() < 1025){
                $('.alternating-images-list img:nth-child(n+3)').removeClass('active');
                order = [2,1];
            }
        }
        updateImagesList();
        $(window).on('resize', updateImagesList);
        function alternatingImages() {
            alternatingImagesInterval = setInterval(function() {
                const imagesList = $('.alternating-images-list img:not(.active)');
                const randomNumber = Math.floor(Math.random() * imagesList.length);
                const randomImage = imagesList.eq(randomNumber);
                const imageToAppend = randomImage.clone();
                imageToAppend.css('opacity', 0);
                const imageIndex = $(`.alternating-images-block:nth-child(${order[index]}) img`).attr('data-id');
                $(`.alternating-images-block:nth-child(${order[index]})`).append(imageToAppend);
                randomImage.addClass('active');
                clearInterval(alternatingImagesInterval);
                $(`.alternating-images-block:nth-child(${order[index]}) img[data-id="${imageIndex}"]`).css('opacity', 0);
                setTimeout(function() {
                    imageToAppend.css('opacity', 1);
                }, 100);
                setTimeout(function() {
                    $(`.alternating-images-block:nth-child(${order[index]}) img[data-id="${imageIndex}"]`).remove();
                    $(`.alternating-images-list img[data-id="${imageIndex}"]`).removeClass('active');
                    index = (index + 1) % order.length;
                    alternatingImages();
                }, 1300);
            }, 2000);
        }
        alternatingImages();
    }

    if($('.marquee').length){
        const carousels = $('.marquee');
        const args = {
            accessibility: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            resize: false
        };
        let speed = 0.5;
        carousels.each(function () {
            const carousel = $(this);
            let requestId, direction;
            if (carousel.children().length > 3) {
                const mainTicker = new Flickity(this, args);

                // Set initial position to be 0
                mainTicker.x = 0;

                // Main function that 'plays' the marquee.
                function play() {
                    mainTicker.x = mainTicker.x - speed;
                    mainTicker.settle(mainTicker.x);
                    requestId = window.requestAnimationFrame(play);
                }
                // Start the marquee animation
                play();
            }
        });
    }



    if($('.product-media-slider').length){
        var $carousel = $('.product-media-slider').flickity({  
            pageDots: false,
            cellAlign: 'left',
            imagesLoaded: true,
            wrapAround: true,
            contain: true,
            setGallerySize: false,
            arrowShape: 'M43.5374 6.1979L49.2711 11.883L15.4519 45.6537L100 45.6537V53.8169L15.4519 53.8169L49.2711 87.5876L43.5374 93.2727L0 49.7353L43.5374 6.1979Z',
            on: {
                change: function( index ) {
                    const sliderElement = this.element;
                    $(sliderElement).siblings('.product-thumbs-slider').find('.product-media-slide').eq(index).addClass('is-selected').siblings().removeClass('is-selected');
                    //scroll to thumb
                    const thumbList = $(sliderElement).siblings('.product-thumbs-slider');
                    const thumbTop = thumbList.find('.product-media-slide').eq(index).offset().top;
                    const thumbHeight = thumbList.find('.product-media-slide').eq(index).outerHeight();
                    const thumbBottom = thumbTop + thumbHeight;
                    const thumbListTop = thumbList.offset().top;
                    const thumbListHeight = thumbList.outerHeight();
                    const thumbListBottom = thumbListTop + thumbListHeight;
                    if(thumbTop < thumbListTop){
                        thumbList.animate({ scrollTop: thumbList.scrollTop() - (thumbListTop - thumbTop) }, 300);
                    }else if(thumbBottom > thumbListBottom){
                        thumbList.animate({ scrollTop: thumbList.scrollTop() + (thumbBottom - thumbListBottom) }, 300);
                    }
                }
            }
        });  
        
        const $thumbList = $('.product-thumbs-slider');
        // Function to update the slider based on screen size  
        function updateSlider() {  
            var windowWidth = $(window).width();  
            var $cells;   
            var $thumbCells;  
      
            if (windowWidth <= 768) {  
                // Include all children with .mobile and .both class  
                $cells = $('.product-media-slider-list').children('.mobile-image, .both-image').clone();  
                $thumbCells = $cells.clone();
            } else {  
                // Include all children with .desktop and .both class  
                $cells = $('.product-media-slider-list').children('.desktop-image, .both-image').clone(); 
                $thumbCells = $cells.clone();
            }  
      
            // Remove all existing cells and add the new ones  
            $carousel.flickity('remove', $carousel.find('.product-media-slide')); // Remove existing cells  
            $carousel.flickity('append', $cells); // Append new cells  
            $carousel.flickity('reposition'); // Reposition the slider  

            $thumbList.empty().append($thumbCells);
            $thumbList.find('.product-media-slide').eq(0).addClass('is-selected').siblings().removeClass('is-selected');
        }  

        let mouseDown = false;
        let startY, scrollTop;

        const startDragging = (e) => {
            mouseDown = true;
            startY = e.pageY - $thumbList.offset().top;
            scrollTop = $thumbList.scrollTop();
        };

        const stopDragging = () => {
            mouseDown = false;
        };

        const move = (e) => {
            e.preventDefault();
            if (!mouseDown) return;
            const y = e.pageY - $thumbList.offset().top;
            const scroll = y - startY;
            $thumbList.scrollTop(scrollTop - scroll);
        };

        // Add the event listeners
        $thumbList.on('mousemove', move);
        $thumbList.on('mousedown', startDragging);
        $thumbList.on('mouseup mouseleave', stopDragging);

        $(document).on('click', '.product-thumbs-slider .product-media-slide', function() {
            $(this).addClass('is-selected').siblings().removeClass('is-selected');
            const index = $(this).index();
            $carousel.flickity('select', index);
            //scroll to thumb
            const thumbTop = $(this).offset().top;
            const thumbHeight = $(this).outerHeight();
            const thumbBottom = thumbTop + thumbHeight;
            const thumbListTop = $thumbList.offset().top;
            const thumbListHeight = $thumbList.outerHeight();
            const thumbListBottom = thumbListTop + thumbListHeight;
            if(thumbTop < thumbListTop){
                thumbList.animate({ scrollTop: thumbList.scrollTop() - (thumbListTop - thumbTop) }, 300);
            }else if(thumbBottom > thumbListBottom){
                thumbList.animate({ scrollTop: thumbList.scrollTop() + (thumbBottom - thumbListBottom) }, 300);
            }
        });

        // Track the last window width to check for changes  
        var lastWidth = $(window).width();  
      
        // On window resize  
        $(window).resize(function() {  
            var currentWidth = $(window).width();  
            // Only reinitialize if the width has changed  
            if (currentWidth !== lastWidth) {  
                updateSlider();  
                lastWidth = currentWidth; // Update lastWidth  
            }  
        });  
      
        // Initial call to set up the slider correctly on page load  
        updateSlider();  
        
    }

    /* Review Boxes */
    if($('.reviews-boxes').length){
        $('.reviews-boxes').each(function() {
            const reviewsPhoto = $(this).parent().siblings('.reviews-photos');
            $('.reviews-boxes').flickity({
                pageDots: false,
                cellAlign: 'center',
                prevNextButtons: false,
                imagesLoaded: true,
                wrapAround: true,
                contain: true,
                watchCSS: true,
                on: {
                    change: function( index ) {
                        const sliderElement = this.element;
                        $(sliderElement).siblings('.mobile-slider-navigation').find('.current').text(index + 1);
                        reviewsPhoto.find('.reviews-photo').eq(index).addClass('active').siblings().removeClass('active');
                    }
                }
            });
        });
    }

    /* Featured Collection */
    if($('.featured-collection-v2').length){
        $('.featured-collection-v2 .product-grid').flickity({
            pageDots: false,
            cellAlign: 'center',
            prevNextButtons: false,
            imagesLoaded: true,
            wrapAround: true,
            contain: true,
            watchCSS: true,
            on: {
                change: function( index ) {
                    const sliderElement = this.element;
                    const newIndex = index + 1;
                    const multiplier = 2 * index + 1;
                    $(sliderElement).siblings('.mobile-slider-navigation').find('.current').text(newIndex);
                    if($(this.element).hasClass('product-grid')){
                        const animatedLetter = $(this.element).parents('.featured-collection-v2').find('.animated-letter');
                        let newContent = '';
                        for (var i = 0; i < multiplier; i++) {
                            newContent += animatedLetter.attr('data-letter');
                        }
                        animatedLetter.text(newContent);
                    }
                }
            }
        });
    }

    /* Text with Rows */
    function initActiveRow() {
        if($(window).width() < 1025){
            const descriptionHeight = $('.text-rows .text-row.active').find('.text-row-description p').outerHeight();
            $('.text-rows .text-row.active').find('.text-row-description').outerHeight(descriptionHeight);
        }else{
            $('.text-rows .text-row.active').find('.text-row-description').removeAttr('style');
        }
    }
    if($('.text-rows').length){
        initActiveRow();
        $(window).on('resize', initActiveRow);
        $(document).on('click', '.text-rows .text-row h3', function() {
            if($(window).width() < 1025){
                const parent = $(this).parent();
                const grandParent = parent.parent();
                parent.toggleClass('active');
                grandParent.siblings().find('.text-row-inner').removeClass('active');
                grandParent.siblings().find('.text-row-description').outerHeight(0);
                if(parent.hasClass('active')){
                    $(this).next().outerHeight($(this).next().find('p').outerHeight());
                }else{
                    $(this).next().outerHeight(0);
                }
            }
        });
    }

    $(document).on('click', '.mobile-slider-navigation .slider-next', function() {
        const sliderElement = $(this).parent().prev()[0];
        $(sliderElement).flickity('next');
    });
    $(document).on('click', '.mobile-slider-navigation .slider-prev', function() {
        const sliderElement = $(this).parent().prev()[0];
        $(sliderElement).flickity('previous');
    });

    /* Quantity Selector */
    $(document).on('click', '.cart-item .quantity-value', function(e){
        e.preventDefault();
        $('.cart-item .quantity-value').not(this).removeClass('open');
        $('.cart-item .quantity-options').not($(this).next()).css('height', 0);
        $(this).toggleClass('open');
        if($(this).hasClass('open')){
            $(this).next().css('height', 100);
        }else{
            $(this).next().css('height', 0);
        }
    });
    $(document).on('click', '.quantity-options li', function(e){
        e.preventDefault();
        const quantity = $(this).text();
        const quantityOptions = $(this).parents('.quantity-options');
        const quantityInput = $(this).parents('.quantity-popover-container').find('.quantity__input');
        const cartItems = $(this)[0].closest('cart-items') || $(this)[0].closest('cart-drawer-items');
        const quantityValue = quantityOptions.prev();
        quantityValue.text(quantity);
        quantityInput.val(quantity).change();
        //updateQuantity
        cartItems.updateQuantity(quantityOptions.attr('data-index'), quantity);
        quantityValue.removeClass('open');
        quantityOptions.css('height', 0);
    });

    //Check URL for cart open
    function getUrlParams(url) {
        const params = {};
        const paramArray = url.slice(url.indexOf('?') + 1).split('&');

        for (let i = 0; i < paramArray.length; i++) {
          const param = paramArray[i].split('=');
          params[param[0]] = param[1];
        }
        return params;
    }
    const currentUrl = window.location.href;
    var urlParams = getUrlParams(currentUrl);

    if (urlParams['cart'] === 'open') {
        const cartLink = $('#cart-icon-bubble')[0];
        const cartDrawer = $('cart-drawer')[0];
        cartDrawer.open(cartLink);
        const url = window.location.href;
        const urlWithoutParams = url.substring(0, url.indexOf('?'));
        window.history.replaceState({}, document.title, urlWithoutParams);
    }

    //Click outside event
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.cart-item .quantity-dropdown').length) {
            $('.cart-item .quantity-value').removeClass('open');
            $('.cart-item .quantity-options').css('height', 0);
        }
    });

    //FAQ
    $(document).on('click', '.faq-question', function() {
        $(this).toggleClass('open');
        const siblings = $(this).parent().siblings();
        siblings.find('.faq-question').removeClass('open');
        siblings.find('.faq-answer').css('height', 0);
        if($(this).hasClass('open')){
            $(this).next().css('height', $(this).next().find('.faq-answer-inner').outerHeight());
        }else{
            $(this).next().css('height', 0);
        }
    });

    //Account Page
    $(document).on('click','.recover-link', function(){
        $('#login-form').addClass('hidden');
        $('#recover-form').removeClass('hidden');
    })
    $(document).on('click','.cancel-recover', function(){
        $('#login-form').removeClass('hidden');
        $('#recover-form').addClass('hidden');
    })

    $(document).on('click','#cart-icon-bubble-mobile',function(e){
        e.preventDefault();


        const cartLink = $('#cart-icon-bubble')[0];
        const cartDrawer = $('cart-drawer')[0];
        cartDrawer.open(cartLink);
        $('#CartDrawer .drawer__inner').animate({
            scrollTop: $('#cart-drawer-content').position().top
        }, 0);
        $('.section-header').addClass('cart-open');
    });


    //CSS Vars Functions
    function setAnnouncementBarHeight() {
        let announcementBarHeight = 0;
        const announcementText = $('.announcement-bar-v2 .announcement-text');
        announcementText.each(function() {
            const textHeight = $(this).outerHeight();
            if(textHeight > announcementBarHeight || !announcementBarHeight){
                announcementBarHeight = textHeight;
            }
        });
        if(announcementBarHeight > 0){
            announcementBarHeight = announcementBarHeight + 24;
            document.documentElement.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
        }
    }
    function headerHeightVariableHeight(){
        const headerHeight = $('.section-header').outerHeight();
        let headerHeightVar = headerHeight - $(window).scrollTop();
        if (headerHeightVar < 0) {
            headerHeightVar = 0;
        }
        document.documentElement.style.setProperty('--header-height-variable', headerHeightVar + 'px');
    }
    function landingCaptionHeight() {
        const landingCaptionHeight = $('.landing-caption').outerHeight();
        document.documentElement.style.setProperty('--landing-captions-height', landingCaptionHeight + 'px');
    }
    function newsletterPlaceholder() {
        if ($(window).width() > 1024 ) {
            $(".footer-newsletter input[type='email']").attr("placeholder","your email");
        }
        else { 
            $(".footer-newsletter input[type='email']").attr("placeholder","enter email for updates");
        }
    }
    newsletterPlaceholder();

    //Resize Event
    let resizeTimer;
    let previousWidth = $(window).width();

    $(window).on('resize', function() {
        const currentWidth = $(window).width();

        newsletterPlaceholder();
        $('.sidebar-menu').addClass('no-transition');

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            $('.sidebar-menu').removeClass('no-transition');
        }, 250);

        if (currentWidth !== previousWidth) {
            previousWidth = currentWidth;

            if ($('.announcement-bar-v2').length) {
                setAnnouncementBarHeight();
            }

            if ($('.section-header').length) {
                headerHeightVariableHeight();
            }

            if ($('.landing-caption').length) {
                landingCaptionHeight();
            }
        }
    });


    function mainProductScroll(){
        if($(window).scrollTop() >= $('.main-product').offset().top + $('.main-product').outerHeight() - 300){
            $('.sticky-product-widget').addClass('show');
        }else{
            $('.sticky-product-widget').removeClass('show');
        }
    }
    $(document).on('click','.back-to-product',function(){
        $('html, body').animate({
            scrollTop: $('.product-info').offset().top - 200
        }, 500);
    });

    $(document).on('click', '.bsub-popover-trigger', function(e) {
        e.preventDefault();
        $('.bsub-popover').toggleClass('show');
    });
    $(document).on('click', '.bsub-popover-close', function(e) {
        e.preventDefault();
        $('.bsub-popover').removeClass('show');
    });
    $(document).on('change','#bsub-options-trigger', function(){
        const value = $(this).val();
        const parent = $(this).parents('.bsub-widget__wrapper');
        const radioParent = $(this).parents('.bsub-widget__group');
        parent.find(`[data-bsub-selling-plan-input][value=${value}]`).prop('checked', true).trigger('change');
        radioParent.find(`[data-bsub-selling-plan-group-input]`).prop('checked', true).trigger('change');
    });


    $(document).on('click', '.sticky-emoji-text button', function() {
        if($(window).width() < 1025){
            const parent = $(this).parents('.text-sticky-emoji-section');
            parent.addClass('popup-expanded');
            const mobilePopup = parent.find('.mobile-popup');
            const currentText = $(this).parents('.sticky-emoji-text');
            const headingText = currentText.find('h3').text();
            const descriptionText = currentText.find('.sticky-emoji-description').text();
            mobilePopup.find('.popup-title').text(headingText);
            mobilePopup.find('.popup-description').text(descriptionText);
            if(parent.hasClass('popup-expanded')){
                const popupHeight = mobilePopup.find('.mobile-popup-inner').outerHeight() + 40;
                mobilePopup.outerHeight(popupHeight).addClass('show');
            }else{
                mobilePopup.outerHeight(0).removeClass('show');
            }
        }
    });
    $(document).on('click', '.mobile-popup-inner .close-popup', function() {
        const parent = $(this).parents('.text-sticky-emoji-section');
        const mobilePopup = parent.find('.mobile-popup');
        mobilePopup.outerHeight(0).removeClass('show');
        parent.removeClass('popup-expanded');
    });

    function setPriceBsub(){
        const checkedOption = $('[name="bsub-selling-plan-group"]:checked');
        checkedOption.parents('.bsub-widget__group').addClass('active').siblings().removeClass('active');
        const price = checkedOption.parent().find('.bsub-price').text();
        $('.quick-add__submit').find('.atc-price').text(price);
    }
    if($('[name="bsub-selling-plan-group"]').length){
        setPriceBsub();
    }
    $(document).on('change', '[name="bsub-selling-plan-group"]', function() {
        setPriceBsub();
    });
    $(document).on('click', '.bsub-widget__group', function() {
        $(this).find('[name="bsub-selling-plan-group"]').prop('checked', true).trigger('change');
    });

    $(window).on('scroll', function() {
        if ($('.landing-caption').length) {
            landingCaptionHeight();
        }

        if($('.featured-collection-v2').length){
            updateLetterContent();
        }

        if($('.main-product').length){
            mainProductScroll();
        }
        //Text with Circles
        if($('.text-with-circles').length){
            //if scrollTop past .sticky-images, make it fixed and set the top position to scroll position
            const scrollTop = $(window).scrollTop();
            const scrollBottom = scrollTop + $(window).height();
            const stickyImageTop = $('.text-with-circles .sticky-images').offset().top;
            const bottomSpace = $(window).outerHeight() - $('.text-with-circles .sticky-images-inner').outerHeight() - 40;
            const mainContent = $('#MainContent').offset().top + $('#MainContent').outerHeight() + bottomSpace;
            if(scrollBottom >= mainContent){
                $('.text-with-circles .sticky-images-inner').css({
                    'position': 'fixed',
                    'top': mainContent - scrollBottom + 20
                });
            }else if(scrollTop >= stickyImageTop - 20){
                const stickyImageTotal = $('.text-with-circles .sticky-images .sticky-image').length;
                const heightToScroll = $('#MainContent').offset().top + $('#MainContent').outerHeight() - stickyImageTop;
                const perHeight = heightToScroll / stickyImageTotal;
                const scrollDiff = scrollTop - stickyImageTop;
                const opacityLevel = Math.round((scrollDiff % perHeight) / perHeight * 10) / 10;;
                const leavingIndex = Math.floor(scrollDiff / perHeight);
                const enteringIndex = leavingIndex + 1;
                if(leavingIndex >= 0){
                    $('.text-with-circles .sticky-images .sticky-image').eq(leavingIndex).css('opacity', 1 - opacityLevel);
                }
                if(enteringIndex < stickyImageTotal && enteringIndex > 0){
                    $('.text-with-circles .sticky-images .sticky-image').eq(enteringIndex).css('opacity', opacityLevel);
                }
                $('.text-with-circles .sticky-images-inner').css({
                    'position': 'fixed',
                    'top': '20px'
                });
            }else{
                $('.text-with-circles .sticky-images-inner').css({
                    'position': 'absolute',
                    'top': 0
                });
            }
        }

        if($('.landing-captions').length){
            if($(window).scrollTop() >= 50){
                $('.landing-captions').addClass('solution');
            }else{
                $('.landing-captions').removeClass('solution');
            }
        }

        if($('.landing-v2-text').length){
            if($(window).scrollTop() >= 50){
                $('.landing-v2-section .landing-circle').addClass('solution');
            }else{
                $('.landing-v2-section .landing-circle').removeClass('solution');
            }
        }
        
    });

    $(document).on('click', '.open-chat-popup', function() {
        const shadowHost = document.querySelector('inbox-online-store-chat');
        const shadowRoot = shadowHost.shadowRoot;
        const button = shadowRoot.querySelector('button');
        button.click();
        $('#shopify-chat').addClass('open');
    });

    setTimeout(function() {
        const chatElement = document.querySelector('inbox-online-store-chat');
        const chatObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'is-open') {
            const isOpen = chatElement.getAttribute('is-open');
            
            // If is-open is 'false', remove the .open class from the parent
            if (isOpen === 'false') {
                const parentElement = chatElement.parentElement;
                if (parentElement.classList.contains('open')) {
                parentElement.classList.remove('open');
                }
            }
            }
        });
        });

        chatObserver.observe(chatElement, {
            attributes: true // Watch for attribute changes
        });
    }, 1000);

    if($('body').hasClass('template-product')){
        const subscriptionObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    $('.shopify_subscriptions_app_block_label').first().addClass('is-selected');
                }
            });
        });

        subscriptionObserver.observe(document.querySelector('.shopify_subscriptions_app_block_container'));
    }

});
